import { render, staticRenderFns } from "./insertEmployee2.vue?vue&type=template&id=0c65ac71&"
import script from "./insertEmployee2.vue?vue&type=script&lang=js&"
export * from "./insertEmployee2.vue?vue&type=script&lang=js&"
import style0 from "./insertEmployee2.vue?vue&type=style&index=0&id=0c65ac71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports